import React from 'react';
import PropTypes from 'prop-types';
import { FaRegEdit } from 'react-icons/fa';
import history from 'routing/history';
import { StyledSectionHeading } from './styled';

const SectionHeading = ({ children, link }) => {
  return (
    <StyledSectionHeading>
      {children}
      <FaRegEdit onClick={() => history.push(link)} />
    </StyledSectionHeading>
  );
};

SectionHeading.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string.isRequired
};

export default SectionHeading;
